import { render, staticRenderFns } from "./VideoGridSinging.vue?vue&type=template&id=4ab97d2a&scoped=true&"
import script from "./VideoGridSinging.vue?vue&type=script&lang=ts&"
export * from "./VideoGridSinging.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGridSinging.vue?vue&type=style&index=0&id=4ab97d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab97d2a",
  null
  
)

export default component.exports